// src/components/auth/ForgotPasswordModal.jsx

import React, { useEffect, useMemo, useState } from "react";
import "./LoginModal.css";

import { apiFetch } from "../../api/apiClient";
import { showGlobalWarning } from "../../services/globalMessage";


const API_BASE = (
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_BASE ||
  "https://api.chbtkd.ir"
).replace(/\/+$/, "");



const SEND_URL =
  `${API_BASE}/api/auth/password/forgot/send/`;

const VERIFY_URL =
  `${API_BASE}/api/auth/password/forgot/verify/`;

const RESET_URL =
  `${API_BASE}/api/auth/password/reset/`;




// نرمال سازی ارقام

const normalizeDigits = (s = "") => {

  const fa = "۰۱۲۳۴۵۶۷۸۹";
  const ar = "٠١٢٣٤٥٦٧٨٩";


  return String(s)
    .trim()
    .replace(/[۰-۹٠-٩]/g, (d)=>{

      const iFa = fa.indexOf(d);

      if(iFa > -1)
        return String(iFa);


      const iAr = ar.indexOf(d);

      if(iAr > -1)
        return String(iAr);


      return d;

    });

};





const ForgotPasswordModal = ({
  onClose
}) => {



  const [step,setStep] =
    useState("phone");



  const [phone,setPhone] =
    useState("");



  const [code,setCode] =
    useState("");



  const [newPassword,setNewPassword] =
    useState("");



  const [confirmPassword,setConfirmPassword] =
    useState("");



  const [loading,setLoading] =
    useState(false);



  const [result,setResult] =
    useState(null);



  const [cooldown,setCooldown] =
    useState(0);




  useEffect(()=>{

    if(!cooldown)
      return;


    const timer =
      setInterval(()=>{

        setCooldown(
          c=>c > 0 ? c-1 : 0
        );

      },1000);



    return ()=>clearInterval(timer);


  },[cooldown]);





  useEffect(()=>{


    const prev =
      document.body.style.overflow;


    document.body.style.overflow =
      "hidden";



    return ()=>{

      document.body.style.overflow =
        prev;

    };


  },[]);





  const canResend =
    useMemo(
      ()=>cooldown===0,
      [cooldown]
    );
  // ارسال شماره موبایل و درخواست کد

  const handleSendCode = async (e) => {

    e.preventDefault();



    const normalizedPhone =
      normalizeDigits(phone);



    if(
      !normalizedPhone ||
      normalizedPhone.length !== 11 ||
      !normalizedPhone.startsWith("09")
    ){

      showGlobalWarning(
        "شماره موبایل معتبر نیست.",
        "خطا"
      );

      return;

    }




    if(!canResend){

      return;

    }



    setLoading(true);



    try{


      const res =
        await apiFetch(

          SEND_URL,

          {

            method:"POST",

            headers:{
              "Content-Type":
              "application/json"
            },


            body:JSON.stringify({

              phone:
              normalizedPhone

            }),


            errorTitle:
            "ارسال کد بازیابی"

          }

        );




      if(!res.ok)
        return;



      setPhone(
        normalizedPhone
      );


      setStep(
        "code"
      );


      setCooldown(
        180
      );



    }

    catch(error){

      console.error(
        "SEND_CODE_ERROR",
        error
      );

    }


    finally{

      setLoading(false);

    }


  };







  // تایید کد چهار رقمی


  const handleVerifyCode = async(e)=>{


    e.preventDefault();



    if(
      !code ||
      code.length !== 4
    ){

      showGlobalWarning(
        "کد چهار رقمی را وارد کنید.",
        "خطا"
      );

      return;

    }




    setLoading(true);



    try{


      const res =
        await apiFetch(

          VERIFY_URL,

          {

            method:"POST",

            headers:{
              "Content-Type":
              "application/json"
            },


            body:JSON.stringify({

              phone,

              code:
              normalizeDigits(code)

            }),


            errorTitle:
            "تایید کد"

          }

        );




      if(!res.ok)
        return;




      setStep(
        "reset"
      );


    }


    catch(error){

      console.error(
        "VERIFY_CODE_ERROR",
        error
      );

    }



    finally{

      setLoading(false);

    }


  };








  // ذخیره رمز جدید


  const handleResetPassword = async()=>{



    if(
      !newPassword ||
      !confirmPassword
    ){

      showGlobalWarning(
        "رمز جدید و تکرار آن را وارد کنید.",
        "اطلاعات ناقص"
      );

      return;

    }





    if(
      newPassword !== confirmPassword
    ){

      showGlobalWarning(
        "رمزهای عبور یکسان نیستند.",
        "خطا"
      );

      return;

    }





    if(newPassword.length < 6){

      showGlobalWarning(
        "رمز عبور باید حداقل ۶ کاراکتر باشد.",
        "رمز نامعتبر"
      );

      return;

    }




    setLoading(true);



    try{


      const res =
        await apiFetch(

          RESET_URL,

          {

            method:"POST",

            headers:{
              "Content-Type":
              "application/json"
            },


            body:JSON.stringify({

              phone,

              password:
              newPassword,


              confirm_password:
              confirmPassword

            }),


            errorTitle:
            "تغییر رمز عبور"

          }

        );




      if(!res.ok)
        return;




      setResult({

        message:
        "رمز عبور شما با موفقیت تغییر کرد."

      });



      setStep(
        "result"
      );



    }


    catch(error){

      console.error(
        "RESET_PASSWORD_ERROR",
        error
      );

    }


    finally{

      setLoading(false);

    }


  };







  return (

    <div
      className="login-modal-backdrop"
      dir="rtl"
    >


      <div
        className="login-modal-container"
      >


        <button

          className="login-close-btn"

          onClick={onClose}

        >

          ×

        </button>





        <div className="login-modal-content">


          <h2>
            فراموشی رمز عبور
          </h2>





          {
          step === "phone" && (


            <form
              className="login-form"
              onSubmit={handleSendCode}
            >


              <p className="login-subtext">

                شماره موبایل خود را وارد کنید.

              </p>



              <input

                className="login-input-field"

                value={phone}

                onChange={
                  e=>setPhone(e.target.value)
                }

                placeholder="شماره موبایل"

                dir="ltr"

              />



              <button

                className="login-action-btn"

                disabled={loading}

              >

                {
                loading
                ?
                "در حال ارسال..."
                :
                "دریافت کد"
                }


              </button>


            </form>


          )
          }
                    {
          step === "code" && (


            <form
              className="login-form"
              onSubmit={handleVerifyCode}
            >


              <p className="login-subtext">

                کد ارسال شده را وارد کنید.

              </p>



              <div className="otp-container" dir="ltr">
                {[0,1,2,3].map((index)=>(
                  <input
                    key={index}
                    className="otp-input"
                    type="text"
                    maxLength="1"
                    value={code[index] || ""}
                    onChange={(e)=>{

                      const value = e.target.value.replace(/\D/g,"");

                      let arr = code.split("");

                      arr[index] = value;

                      const newCode = arr.join("");

                      setCode(newCode);


                      if(value && index < 3){
                        document
                        .getElementById(`otp-${index+1}`)
                        ?.focus();
                      }

                    }}

                    onKeyDown={(e)=>{

                      if(e.key==="Backspace" && !code[index] && index>0){

                        document
                        .getElementById(`otp-${index-1}`)
                        ?.focus();

                      }

                    }}

                    id={`otp-${index}`}
                  />
                ))}
              </div>




              <button

                className="login-action-btn"

                disabled={loading}

              >

                {
                loading
                ?
                "در حال بررسی..."
                :
                "تایید کد"
                }


              </button>





              <button

                type="button"

                className="login-resend-btn"

                disabled={!canResend || loading}

                onClick={handleSendCode}

              >

                {
                cooldown > 0

                ?

                `ارسال مجدد (${cooldown})`

                :

                "ارسال مجدد کد"

                }


              </button>



            </form>


          )
          }








          {
          step === "reset" && (



            <div
              className="login-form"
            >



              <p className="login-subtext">

                رمز عبور جدید خود را وارد کنید.

              </p>





              <input

                className="login-input-field"

                type="password"

                value={newPassword}

                onChange={
                  e =>
                  setNewPassword(
                    e.target.value
                  )
                }

                placeholder="رمز عبور جدید"

                dir="ltr"

              />





              <input

                className="login-input-field"

                type="password"

                value={confirmPassword}

                onChange={
                  e =>
                  setConfirmPassword(
                    e.target.value
                  )
                }

                placeholder="تکرار رمز عبور جدید"

                dir="ltr"

              />






              <button

                className="login-action-btn"

                onClick={handleResetPassword}

                disabled={loading}

              >

                {
                loading

                ?

                "در حال ذخیره..."

                :

                "ذخیره رمز عبور"

                }


              </button>




            </div>


          )
          }







          {
          step === "result" && result && (



            <div
              className="login-form"
            >



              <p className="login-subtext">

                {result.message}

              </p>




              <button

                className="login-action-btn"

                onClick={onClose}

              >

               باشه

              </button>




            </div>


          )
          }





        </div>


      </div>


    </div>

  );


};


export default ForgotPasswordModal;